import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from "@angular/common";
import { Constants } from '../_helpers';
@Pipe({ name: 'currencySymbol' })
export class CurrencySymbolPipe extends CurrencyPipe implements PipeTransform {
    transform(value: string): any {
        // let currencyValue = super.transform(0, value, 'symbol-narrow', "1.0-2");
        let currencyValue;
        if(Constants.CLIENT_CODE == 'guinee') {
            currencyValue = super.transform(0, value, 'symbol', "1.0-2");
        } else {
            currencyValue = super.transform(0, value, 'symbol-narrow', "1.0-2");
        }
        return currencyValue.replace(/[0-9]/g, '');
    }
}
